import { useCallback, useState } from 'react';
import { readSendOnEnter, writeSendOnEnter } from '../utils/sendOnEnter';

export interface UseSendOnEnterResult {
    sendOnEnter: boolean;
    toggleSendOnEnter: () => void;
}

// Each composer passes its own key so its choice persists apart from the others.
export function useSendOnEnter(storageKey: string, defaultValue: boolean): UseSendOnEnterResult {
    const [sendOnEnter, setSendOnEnter] = useState(() => readSendOnEnter(storageKey, defaultValue));

    const toggleSendOnEnter = useCallback(() => {
        const next = !sendOnEnter;
        writeSendOnEnter(storageKey, next);
        setSendOnEnter(next);
    }, [storageKey, sendOnEnter]);

    return { sendOnEnter, toggleSendOnEnter };
}
